import React, { ReactNode } from "react";
import { Box, Typography } from "@mui/material";
import {
  dashboard2SectionDescriptionSx,
  dashboard2SectionIntroSx,
  dashboard2PageIntroSx,
  dashboard2PageIntroTitleSx,
  dashboard2SectionIntroTitleSx
} from "../dashboard2-status.styles";

type Density = "page" | "section" | "compact";

type Dashboard2SectionIntroProps = {
  title: string;
  description?: string;
  titleComponent?: "h1" | "h2" | "h3";
  density?: Density;
  /** Optional control aligned to the top-right of the title row (e.g. Management link). */
  action?: ReactNode;
  "data-testid"?: string;
};

const densitySx = {
  page: dashboard2PageIntroSx,
  section: dashboard2SectionIntroSx,
  compact: dashboard2SectionIntroSx
} as const;

const titleSx = {
  h1: dashboard2PageIntroTitleSx,
  h2: dashboard2SectionIntroTitleSx,
  h3: dashboard2SectionIntroTitleSx
} as const;

export const Dashboard2SectionIntro: React.FC<Dashboard2SectionIntroProps> = ({
  title,
  description,
  titleComponent = "h2",
  density = "section",
  action,
  "data-testid": testId
}) => {
  return (
    <Box sx={densitySx[density]} data-testid={testId}>
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: 2,
          width: "100%"
        }}
      >
        <Typography
          component={titleComponent}
          variant="inherit"
          sx={{ ...titleSx[titleComponent], minWidth: 0, flex: 1 }}
        >
          {title}
        </Typography>
        {action}
      </Box>
      {description && (
        <Typography variant="inherit" color="text.secondary" sx={dashboard2SectionDescriptionSx}>
          {description}
        </Typography>
      )}
    </Box>
  );
};
